import AblogMetaArea from './AblogMetaArea';

const AblogMetaData = ({ metaData, officer }) => {
  const officerColumns =
    officer == 'DECK'
      ? [
          [
            { title: 'Master', field: 'master' },
            { title: 'Chief Officer', field: 'chief_officer' },
          ],
          [{ title: 'Creation Date', field: 'create_date_user' }],
        ]
      : [
          [{ title: 'Chief Engineer', field: 'chief_engineer' }],
          [{ title: 'Creation Date', field: 'create_date_user' }],
          [{ title: 'Last Docking Date', field: 'lastdocking_date' }],
        ];

  const columns = [
    [{ title: 'Ship Name', field: 'ship_name' }],
    [{ title: 'Voyage No.', field: 'voyage_no' }],
    [
      { title: 'Port From', field: 'port_from' },
      { title: 'Port To', field: 'port_to' },
    ],
    [
      { title: "Com'ced Voyage Date & Time", field: 'date_from' },
      { title: 'Completed Voyage Date & Time', field: 'date_to' },
    ],
    [{ title: 'Total Hour', field: 'total_hour' }],
    ...officerColumns,
    [{ title: 'Remarks', field: 'remarks' }],
  ];

  return <AblogMetaArea columns={columns} metaData={metaData} />;
};

export default AblogMetaData;
